import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { UserEarlyAccessResponse } from '../../LandingScreens/Types/EarlyAccessType';
import { getAllEarlyAccessDataByRole } from '../../LandingScreens/Service/EarlyAccessService';
import EarlyAccessUsersComponent from '../Components/EarlyAccessUsersComponent';

const FETCH_SIZE = 1000;

function EarlyAccessByRolePage() {
  const [adminData, setAdminData] = useState<UserEarlyAccessResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');

  const { role } = useParams();

  const fetchEarlyAccess = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getAllEarlyAccessDataByRole(role as string, 0, FETCH_SIZE);
      if (response.success) {
        setAdminData(response.data.content ?? []);
        setError('');
      } else {
        setError(response.message || 'Failed to load early access users.');
      }
    } catch (err) {
      setError('Failed to load early access users.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [role]);

  useEffect(() => {
    fetchEarlyAccess();
  }, [fetchEarlyAccess]);

  const roleLabel =
    role === 'recruiter'
      ? 'Early Access Recruiters'
      : role === 'candidate'
      ? 'Early Access Candidates'
      : `Early Access ${role ?? ''}`.trim();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 p-8 text-sm font-semibold text-slate-400">
        Loading early access users...
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-slate-950 p-8 text-sm font-semibold text-rose-400">
        {error}
      </div>
    );
  }

  return (
    <EarlyAccessUsersComponent
      data={adminData}
      menuName={roleLabel}
      role={role}
      onChanged={fetchEarlyAccess}
    />
  );
}

export default EarlyAccessByRolePage;
